import { inject } from '@angular/core';
import { CanActivateFn } from '@angular/router';
import { filter } from 'rxjs/operators';
import { PermissionService } from '../services/permission.service';

export const authGuard: CanActivateFn = () => {
    const permissionService: PermissionService = inject(PermissionService);
    return permissionService.isUserAuthorized$.pipe(filter((s) => s !== undefined));
};
